module.exports = __webpack_public_path__ + "media/images/the-information-logo-b3058207.svg";